const setupMarker = Symbol.for("rcd.menu.setup");
const itemSelector = [
    "[role='menuitem']:not([aria-disabled='true'])",
    "[role='menuitemcheckbox']:not([aria-disabled='true'])",
    "[role='menuitemradio']:not([aria-disabled='true'])",
    ".rcd-menu__link:not([aria-disabled='true'])",
    ".rcd-menu__button:not(:disabled)"
].join(",");

const getItems = (menu) => (
    [...menu.querySelectorAll(itemSelector)].filter((item) => !item.hidden)
);

const focusItem = (menu, index) => {
    const items = getItems(menu);
    if (!items.length) {
        return;
    }

    items[((index % items.length) + items.length) % items.length].focus();
};

export const setupRcdMenus = () => {
    if (window[setupMarker]) {
        return;
    }

    window[setupMarker] = true;
    let typeahead = "";
    let typeaheadTimer = 0;

    document.addEventListener("keydown", (event) => {
        const trigger = event.target instanceof Element
            ? event.target.closest("[data-rcd-menu-trigger]")
            : null;
        if (trigger && (event.key === "ArrowDown" || event.key === "ArrowUp")) {
            event.preventDefault();
            window.rcdPopover?.open(trigger);
            const menu = document.getElementById(trigger.getAttribute("popovertarget") || trigger.getAttribute("aria-controls"));
            window.requestAnimationFrame(() => focusItem(menu, event.key === "ArrowDown" ? 0 : -1));
            return;
        }

        const menu = event.target instanceof Element
            ? event.target.closest("[data-rcd-menu]")
            : null;
        if (!menu) {
            return;
        }

        const items = getItems(menu);
        const current = items.indexOf(document.activeElement);
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            focusItem(menu, current + (event.key === "ArrowDown" ? 1 : -1));
        } else if (event.key === "Home" || event.key === "End") {
            event.preventDefault();
            focusItem(menu, event.key === "Home" ? 0 : -1);
        } else if (event.key === "Escape") {
            const triggerId = menu.id;
            const owner = document.querySelector(`[data-rcd-menu-trigger][popovertarget="${CSS.escape(triggerId)}"]`)
                || document.querySelector(`[data-rcd-menu-trigger][aria-controls="${CSS.escape(triggerId)}"]`);
            window.rcdPopover?.close(menu);
            owner?.focus({ preventScroll: true });
        } else if (event.key.length === 1 && !event.ctrlKey && !event.metaKey && !event.altKey) {
            window.clearTimeout(typeaheadTimer);
            typeahead += event.key.toLocaleLowerCase();
            const match = items.find((item) => item.textContent.trim().toLocaleLowerCase().startsWith(typeahead));
            match?.focus();
            typeaheadTimer = window.setTimeout(() => {
                typeahead = "";
            }, 500);
        }
    });

    document.addEventListener("click", (event) => {
        const item = event.target instanceof Element
            ? event.target.closest(itemSelector)
            : null;
        const menu = item?.closest("[data-rcd-menu]");
        if (menu && !item.hasAttribute("data-rcd-menu-keep-open")) {
            window.rcdPopover?.close(menu);
        }
    });
};
